import { Typography } from 'antd';

const { Title } = Typography;

const Heading = ({ children, ...rest }) => {
  return <Title {...rest}>{children}</Title>;
};

export default Heading;
